module.exports = __webpack_public_path__ + "media/images/Mike_Bradburn-77a8ef404576c4f64abdcae51ce9e77a.jpg";